// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","MainHeading":"MainHeading-4khkdb54btpshnt5hb3hnv1qj2gep8yfygnjuqagrwxc6akuavw4bkpkkhrtybjq7m6gqmtxpf1fmz311y45tfng8hnwyravrebndp5","ContentWrapper":"ContentWrapper-394xevkj387xav7g5j8maqb24j52wt2w58zg8gzenpq9ja57qhdj53rjekwkt71at1ugt5cesrkvfr7xdgpdm9xur4tzjgmu4jmnc3c","loading":"loading-4bt2x4um8amasckjpkrb4cxe4ssq58jtb16596qm6tucudpsxpdmjcgdx9766y5v9tza1d56m2dmc8ujx7y1envdgg8pmshc1tqkzk9","pulse":"pulse-28z55cxetpu8zxetmby1641xhyw9347abb7j76ehzsfqztty7kghptd6j2x4nnen7zwvhyxvy34mt5mps1tyjjby9qxxs2bh7dkf2nx"};


//////////////////
// WEBPACK FOOTER
// ./src/views/History/HistoryView.module.scss
// module id = 1642
// module chunks = 0